module.exports = __webpack_public_path__ + "img/ElasticStack.a74aa13.svg";